import * as React from 'react';

export default function EnterpriseMobileLoggedOutMainNav() {
  return <div>EnterpriseMobileLoggedOutMainNav</div>;
}
